var React = require('react');

function CaretRightSmall (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"className":"svg-stroke","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.079","points":"86.859 13.219 84.063 16.215 81.267 13.219","transform":"rotate(-90 38.563 50.217)"}));
}

CaretRightSmall.defaultProps = {"width":"6","height":"9","viewBox":"0 1 6 9"};

module.exports = CaretRightSmall;

CaretRightSmall.default = CaretRightSmall;
